import * as React from "react";
import { PropTypes } from "components/controls";
import Label from "common/components/controls/Label";
import HU from "common/utils/HostovaniDlouhodobaUtils";

export interface StavLabelProps {
    stav: number;
}

class StavLabel extends React.Component<StavLabelProps> {

    render() {

        const { stav } = this.props;
        let label: string;
        let color: PropTypes.Color = 'warning';
        switch (stav) {
            case HU.Stav_PotvrzeniICaDomKC:
                label = 'Potvrzení';
                break;
            case HU.Stav_ZaplaceniPopl:
                label = 'Zaplacení SP';
                break;
            case HU.Stav_Zpracovani:
                label = 'Zpracování sekr.';
                break;
            case HU.Stav_Vyrizeno:
                color = "success";
                label = 'Vyřízeno';
                break;
            case HU.Stav_Ukonceno:
                color = "primary";
                label = 'Ukončeno';
                break;
            case HU.Stav_Zamitnuto:
                color = "danger";
                label = 'Zamítnuto';
                break;
            case HU.Stav_Stornovan:
                color = "danger";
                label = 'Stornováno';
                break;
        }

        return <Label color={color} label={label} />;
    }
}




export default StavLabel;